import { NzModalRef } from 'ng-zorro-antd/modal';
import { AfterContentInit, Component } from '@angular/core';

import { AuthService } from '../../../../core/services';

import { sourceSchainMaxSizePrepareLine } from '../../helpers/source-schain-partner-messages';

@Component({
  selector: 'app-tutorial',
  standalone: false,
  templateUrl: './tutorial.component.html',
  styleUrl: './tutorial.component.scss'
})
export class TutorialComponent implements AfterContentInit {
  protected currentStep = 1;

  protected contentHeight = 'auto';

  protected schainModification = 'pass-all';
  protected completeSchainStatus = 'original';
  protected sourceSchainFile = 'topsources-us';

  constructor(
    private dialogRef: NzModalRef<TutorialComponent>,
    private authService: AuthService,
  ) { }

  protected get maxSizePrepareLine(): string {
    return sourceSchainMaxSizePrepareLine(this.authService.partner.id);
  }

  protected onPrevStep(event: Event): void {
    if (this.currentStep === 1) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    this.currentStep--;
  }

  public ngAfterContentInit(): void {
    this.contentHeight = window.innerHeight - 250 + 'px';
    window.addEventListener('resize', () => {
      this.contentHeight = window.innerHeight - 250 + 'px';
    });
  }

  protected onNextStep(event: Event): void {
    if (this.currentStep === 4) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    this.currentStep++;
  }

  protected onClose(): void {
    this.dialogRef.close();
  }

}
